import React from "react";
// react components used to create a google map
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
  InfoWindow
} from "react-google-maps";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import AddLocation from "@material-ui/icons/AddLocation";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";

import {GOOGLE_MAPS_API_KEY, API_ROOT} from 'api-config';
import { getApiHeaders } from "../../../assets/helpers/apiHelper";
import { formatPhoneNumber } from "../../../assets/helpers/apiHelper";

import axios from "axios";

import { CircularProgress } from '@material-ui/core';
const { compose, withProps, withStateHandlers } = require("recompose");

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
};

class ClientMap extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      markers: [],
      loadingMarkers: true
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.getProspects()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getProspects() {
    this.setState({
      loadingMarkers: true
    })
    axios.get(`${API_ROOT}/cirrusAdmin/prospects/?prospectType=dentist`, {headers: getApiHeaders()})
      .then(res => this.setProspects({responseMessage: res.data}));
  }

  setProspects(res) {
    if (this._isMounted) {
      this.setState({
        markers: res.responseMessage,
        loadingMarkers: false
      })
    }
  }

  selectMapMarker(active) {
    var marker = ''
    if (active) {
      marker = 'https://maps.google.com/mapfiles/ms/icons/green-dot.png'
    } else {
      marker = 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
    }
    return marker
  }


  render() {

    function changeInfoWindowView(openString, index) {
      const indexString = ':' + index + ':'
      if (openString.includes(indexString)) {
        openString = openString.replace(indexString, '')
      } else {
        openString += indexString
      }
      return openString
    }
    const { classes } = this.props;
    const MapWithAMarker = compose(
      withProps({
        googleMapURL: "https://maps.googleapis.com/maps/api/js?key=" + GOOGLE_MAPS_API_KEY + "&v=3.exp",
        loadingElement: <div style={{ height: `100%` }}/>,
        containerElement: <div style={{ height: `600px` }}/>,
        mapElement: <div style={{ height: `100%` }}/>
      }),
      withStateHandlers(() => ({
        openString: ''
      }), {
        onToggleOpen: ({ openString }) => (value) => ({
          openString: changeInfoWindowView(openString, value),
        })
      }),
      withScriptjs,
      withGoogleMap
    )(props =>
      <GoogleMap
        defaultZoom={9}
        defaultCenter={{ lat: 42.305440, lng: -72.768130}}
      >
        {props.markers.map((marker, index) => (
          <Marker
            key={index}
            position={{ lat: marker.latitude, lng: marker.longitude }}
            onClick={() => props.onToggleOpen(index)}
            options={{icon: this.selectMapMarker(marker.active)}}
          >
            {props.openString.includes(':' + index + ':') && <InfoWindow
              onCloseClick={() => props.onToggleOpen(index)}
              options={{ closeBoxURL: ``, enableEventPropagation: true }}
            >
              <div>
                <div>{marker.name}</div>
                <div>{marker.address1}</div>
                <div>{marker.city}, {marker.state} {marker.zip}</div>
                <div>{formatPhoneNumber(marker.phoneNum)}</div>
                <div>{marker.email}</div>
              </div>
            </InfoWindow>}

            {/*<InfoWindow onCloseClick={this.onToggleOpen}> marker.name </InfoWindow>*/}
          </Marker>
        ))}

      </GoogleMap>
    );
    return (
      <GridContainer>

        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="rose" icon>
              <CardIcon color="cirrusBlue">
                <AddLocation />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Dentist Offices</h4>
            </CardHeader>
            <CardBody>
              <div style={this.state.loadingMarkers ? { display: 'none' } : {}} >
              <MapWithAMarker
                markers={this.state.markers}
              />
              </div>
              <div style={this.state.loadingMarkers ? {} : { display: 'none' }}><CircularProgress />loading...</div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    )


  }

}

export default withStyles(styles)(ClientMap);
